import { render, staticRenderFns } from "./SelectCompany.vue?vue&type=template&id=422ed8a4&scoped=true"
import script from "./SelectCompany.vue?vue&type=script&lang=ts"
export * from "./SelectCompany.vue?vue&type=script&lang=ts"
import style0 from "./SelectCompany.vue?vue&type=style&index=0&id=422ed8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422ed8a4",
  null
  
)

export default component.exports